import {
  AlertIcon,
  DayStatOutlineIcon,
  InsulinMedicationIcon,
  RangesIcon,
  SettingsDisplayIcon,
  StatsIcon,
  ThemeIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import type {
  FunctionComponent,
  SVGProps,
} from "react"
import { useMemo } from "react"

import styles from "./SettingsIndex.module.scss"
import {
  PageLink,
  PageTemplate,
} from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"

export function SettingsIndex() {
  const {
    currentFollow,
    currentUserId,
  } = useFollowedUsers()

  const polyglot = usePolyglot()

  const pages = useMemo(
    () => [
      {
        routePath: currentFollow.is_self ? "/settings/alerts" as const : "/settings/alerts/$accountId" as const,
        params: currentFollow.is_self ? {} : { accountId: currentUserId },
        polyglotPhraseKey: "pages.settings.pages.alerts",
        Icon: AlertIcon as FunctionComponent<SVGProps<SVGElement>>,
        id: "Alerts",
      },
      ...(!currentFollow.is_self ? [] : [
        {
          routePath: currentFollow.is_self ? "/settings/ranges" as const : "/settings/ranges/$accountId" as const,
          params: currentFollow.is_self ? {} : { accountId: currentUserId },
          id: "Ranges",
          polyglotPhraseKey: "pages.settings.pages.ranges",
          Icon: RangesIcon as FunctionComponent<SVGProps<SVGElement>>,
        },
      ]),
      {
        routePath: currentFollow.is_self ? "/settings/theme" as const : "/settings/theme/$accountId" as const,
        params: currentFollow.is_self ? {} : { accountId: currentUserId },
        polyglotPhraseKey: "pages.settings.pages.theme",
        Icon: ThemeIcon as FunctionComponent<SVGProps<SVGElement>>,
        id: "Theme",
      },
      {
        routePath: currentFollow.is_self ? "/settings/display" as const : "/settings/display/$accountId" as const,
        params: currentFollow.is_self ? {} : { accountId: currentUserId },
        polyglotPhraseKey: "pages.settings.pages.display",
        Icon: SettingsDisplayIcon as FunctionComponent<SVGProps<SVGElement>>,
        id: "Display",
      },
      ...(!currentFollow.is_self ? [] : [
        {
          routePath: "/settings/insulin_and_medication" as const,
          polyglotPhraseKey: "pages.settings.pages.insulin_and_medication",
          Icon: InsulinMedicationIcon as FunctionComponent<SVGProps<SVGElement>>,
          id: "insulin-and-medication-button",
        },
      ]),
      {
        routePath: currentFollow.is_self ? "/settings/day_stats" as const : "/settings/day_stats/$accountId" as const,
        params: currentFollow.is_self ? {} : { accountId: currentUserId },
        id: "day_stats",
        polyglotPhraseKey: "pages.settings.pages.day_stats",
        Icon: DayStatOutlineIcon as FunctionComponent<SVGProps<SVGElement>>,
      },
      {
        routePath: currentFollow.is_self ? "/settings/reports" as const : "/settings/reports/$accountId" as const,
        id: "Reports",
        polyglotPhraseKey: "pages.settings.pages.reports",
        Icon: StatsIcon as FunctionComponent<SVGProps<SVGElement>>,
      },
    ],
    [
      currentFollow,
      currentUserId,
    ],
  )

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.settings")}
    >
      <div className={styles.container}>
        {pages.map(
          (pageLinkProps) => (
            <PageLink
              key={pageLinkProps.routePath}
              {...pageLinkProps}
            />
          ),
        )}
      </div>
    </PageTemplate>
  )
}
